// assets/product-page.js
(function () {
  'use strict';

  var variantsData = [];
  var currentOptions = { option1: null, option2: null };

  // ── Cargar variantes ──
  var variantsScript = document.getElementById('product-variants-json');
  if (!variantsScript) return;
  try {
    variantsData = JSON.parse(variantsScript.textContent);
  } catch (e) { return; }

  // ── Opciones actuales desde variante seleccionada ──
  var config = document.getElementById('pdp-config');
  var currentVariantId = config ? parseInt(config.dataset.currentVariant) : null;
  var currentVariant = variantsData.find(function (v) { return v.id === currentVariantId; });
  if (currentVariant) {
    currentOptions.option1 = currentVariant.option1;
    currentOptions.option2 = currentVariant.option2;
  }

  // ── Encontrar variante por opciones ──
  function findVariant(opt1, opt2) {
    return variantsData.find(function (v) {
      return v.option1 === opt1 && (opt2 === null || v.option2 === opt2);
    });
  }

  // ── Actualizar UI con variante ──
  function updateVariantUI(variant) {
    if (!variant) return;

    // Precio
    var priceEl = document.getElementById('pdp-price');
    var priceRow = document.getElementById('pdp-price-row');
    if (priceEl) {
      if (variant.price > 0) {
        priceEl.textContent = formatMoney(variant.price);
      } else {
        if (priceRow) priceRow.innerHTML = '<span class="pdp-price-consultar">Precio a consultar</span>';
      }
    }

    // Variant ID hidden input
    var variantInput = document.getElementById('pdp-variant-id');
    if (variantInput) variantInput.value = variant.id;

    // Add to cart button
    var addBtn = document.getElementById('pdp-add-btn');
    if (addBtn) {
      addBtn.disabled = !variant.available;
      addBtn.dataset.variantId = variant.id;
      addBtn.textContent = variant.available ? 'Agregar al carrito' : 'Sin stock';
    }

    // Disponibilidad
    var availEl = document.getElementById('pdp-availability');
    if (availEl) {
      if (variant.available) {
        availEl.innerHTML = '<span class="pdp-avail-ok"><svg width="13" height="13" viewBox="0 0 13 13" fill="none"><circle cx="6.5" cy="6.5" r="6" stroke="currentColor" stroke-width="1.2"/><path d="M4 6.5l2 2 3-3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>Disponible · Envío a todo Chile</span>';
      } else {
        availEl.innerHTML = '<span class="pdp-avail-no">Sin stock en esta variante</span>';
      }
    }

    // SKU
    var skuEl = document.getElementById('pdp-sku-val');
    if (skuEl && variant.sku) skuEl.textContent = variant.sku;

    // Imagen de variante
    if (variant.featured_image) {
      var mainPhoto = document.getElementById('pdp-main-photo');
      if (mainPhoto) mainPhoto.src = variant.featured_image;
    }

    // Cuotas
    var cuotaEl = document.getElementById('pdp-cuota-val');
    var cuotasWrap = document.getElementById('pdp-cuotas');
    if (cuotaEl && variant.price > 0) {
      var cuota = Math.round(variant.price / 100 / 12);
      cuotaEl.textContent = '$' + cuota.toLocaleString('es-CL');
      if (cuotasWrap) cuotasWrap.style.display = 'inline-flex';
    } else if (cuotasWrap) {
      cuotasWrap.style.display = 'none';
    }

    // Actualizar URL sin recargar
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  // ── Selección de opciones ──
  document.querySelectorAll('.pdp-opt-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var optionKey = btn.dataset.option;
      var value = btn.dataset.value;

      currentOptions[optionKey] = value;

      // Actualizar botones activos del grupo
      var group = btn.closest('.pdp-option-btns');
      if (group) {
        group.querySelectorAll('.pdp-opt-btn').forEach(function (b) {
          b.classList.toggle('active', b.dataset.value === value);
        });
      }

      // Actualizar label seleccionado
      var labelId = optionKey === 'option1' ? 'selected-capacidad' : 'selected-color';
      var labelEl = document.getElementById(labelId);
      if (labelEl) labelEl.textContent = value;

      // Marcar no disponibles
      updateAvailabilityIndicators();

      // Buscar y aplicar variante
      var variant = findVariant(currentOptions.option1, currentOptions.option2);
      if (variant) updateVariantUI(variant);
    });
  });

  function updateAvailabilityIndicators() {
    // Para cada opción de color, verificar si existe con la capacidad seleccionada
    document.querySelectorAll('#color-btns .pdp-opt-btn').forEach(function (btn) {
      var color = btn.dataset.value;
      var variant = findVariant(currentOptions.option1, color);
      btn.classList.toggle('unavailable', !variant || !variant.available);
    });
  }

  updateAvailabilityIndicators();

  // ── Galería: thumbnails ──
  // ── Galería — thumbnails ──
  document.querySelectorAll('.pdp-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.pdp-thumb').forEach(function (t) {
        t.classList.remove('active');
      });
      thumb.classList.add('active');

      var mainPhoto = document.getElementById('pdp-main-photo');
      if (mainPhoto && thumb.dataset.src) {
        mainPhoto.src = thumb.dataset.src;
        mainPhoto.classList.remove('is-secondary');
      }
    });
  });

  // ── Tabs ──
  document.querySelectorAll('.pdp-tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var tabId = tab.dataset.tab;

      document.querySelectorAll('.pdp-tab').forEach(function (t) {
        t.classList.remove('active');
      });
      tab.classList.add('active');

      document.querySelectorAll('.pdp-tab-content').forEach(function (content) {
        content.style.display = 'none';
        content.classList.remove('active');
      });

      var target = document.getElementById('tab-' + tabId);
      if (target) {
        target.style.display = 'block';
        target.classList.add('active');
      }
    });
  });

  // ── Formatear precio CLP ──
  function formatMoney(cents) {
    return '$' + Math.round(cents / 100).toLocaleString('es-CL');
  }

})();